'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var useTimeValues_hook = require('./use-time-values.hook-1a18dd0a.js');
var amPmValues = require('./am-pm-values-eefc488c.js');
var hourValues = require('./hour-values-6ed34fa3.js');
var minuteValues = require('./minute-values-99a9a46d.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  min-width: 55px;\n\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n\n  padding: 8px 16px;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover:not(.active) {\n    background-color: ", ";\n  }\n\n  &.active {\n    font-weight: 700;\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  min-width: 55px;\n\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n\n  padding: 8px 16px;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover:not(.active) {\n    background-color: ", ";\n  }\n\n  &.active {\n    font-weight: 700;\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var Value = function (_a) {
    var value = _a.value, active = _a.active, onClick = _a.onClick;
    var ref = useTimeValues_hook.useItemScroll(active);
    var handleClick = React.useCallback(function () {
        onClick(value);
    }, [onClick, value]);
    return (React__default.createElement(Container, { ref: ref, className: active ? 'active' : '', onClick: handleClick }, value));
};
var templateObject_1;

var Container$1 = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  height: 192px;\n  padding: 8px 0;\n  font-family: ", ";\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  height: 192px;\n  padding: 8px 0;\n  font-family: ", ";\n  overflow-y: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var Values = function (_a) {
    var values = _a.values, onClick = _a.onClick, onCheckActive = _a.onCheckActive;
    return (React__default.createElement(Container$1, null, values.map(function (value) {
        var timeValue = value.hour + ":" + value.minute + " " + value.amPm;
        var active = onCheckActive(value.hour, value.minute, value.amPm);
        return (React__default.createElement(Value, { key: timeValue, active: active, onClick: onClick, value: timeValue }));
    })));
};
var templateObject_1$1;

var useSingleSelectValues = function (_a) {
    var value = _a.value, onChange = _a.onChange, minuteStep = _a.minuteStep;
    var activeValues = useTimeValues_hook.useTimeValues(value, true);
    var values = React.useMemo(function () {
        var minuteValue = 0;
        var minuteValues = Array.from({ length: 60 / minuteStep }).map(function (_item, index) {
            if (index !== 0) {
                minuteValue += minuteStep;
            }
            return minuteValue === 60 ? '00' : useTimeValues_hook.generateTimePartString(minuteValue);
        });
        var hourValues = Array
            .from({ length: 12 }, function (_, index) { return (index + 1); });
        var valuesAm = [];
        var valuesPm = [];
        hourValues.forEach(function (hour) {
            var hourValue = useTimeValues_hook.generateTimePartString(hour);
            minuteValues.forEach(function (minute) {
                var time = {
                    hour: hourValue,
                    minute: minute,
                };
                valuesAm.push(tslib_es6.__assign(tslib_es6.__assign({}, time), { amPm: hourValue === '12' ? 'pm' : 'am' }));
                valuesPm.push(tslib_es6.__assign(tslib_es6.__assign({}, time), { amPm: hourValue === '12' ? 'am' : 'pm' }));
            });
        });
        return valuesAm.concat(valuesPm);
    }, []);
    var onCheckActive = React.useCallback(function (hour, minute, amPm) {
        var activeMinute = parseInt(activeValues === null || activeValues === void 0 ? void 0 : activeValues.minutes, 10);
        var currentMinute = parseInt(minute, 10);
        return (activeValues === null || activeValues === void 0 ? void 0 : activeValues.amPm) === amPm
            && (activeValues === null || activeValues === void 0 ? void 0 : activeValues.formattedHours) === hour
            && currentMinute <= activeMinute
            && currentMinute + minuteStep > activeMinute;
    }, [activeValues, minuteStep]);
    var handleClick = React.useCallback(function (selected) {
        var _a = tslib_es6.__read(selected.split(' '), 2), time = _a[0], amPm = _a[1];
        var _b = tslib_es6.__read(time.split(':'), 2), hours = _b[0], minutes = _b[1];
        var parsedHours = parseInt(hours, 10) % 12;
        var newHoursValue = amPm === 'pm' ? parsedHours + 12 : parsedHours;
        onChange(useTimeValues_hook.generateTimePartString(newHoursValue) + ":" + minutes);
    }, [onChange]);
    return {
        values: values,
        activeValues: activeValues,
        handleClick: handleClick,
        onCheckActive: onCheckActive,
    };
};

var SingleSelectValues = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.minuteStep, minuteStep = _b === void 0 ? 5 : _b;
    var _c = useSingleSelectValues({ value: value, onChange: onChange, minuteStep: minuteStep }), values = _c.values, handleClick = _c.handleClick, onCheckActive = _c.onCheckActive;
    return (React__default.createElement(Values, { values: values, onClick: handleClick, onCheckActive: onCheckActive }));
};

var Container$2 = styled__default.div(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  display: inline-flex;\n  border: ", ";\n"], ["\n  display: inline-flex;\n  border: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedMediumGrey + " solid 1px";
});
var TimePicker = function (_a) {
    var className = _a.className, _b = _a.is12h, is12h = _b === void 0 ? true : _b, value = _a.value, onChange = _a.onChange, _c = _a.valueHeight, valueHeight = _c === void 0 ? 32 : _c, _d = _a.maxVisible, maxVisible = _d === void 0 ? 6 : _d, _e = _a.min, min = _e === void 0 ? '00:00' : _e, _f = _a.max, max = _f === void 0 ? '23:59' : _f, _g = _a.minuteStep, minuteStep = _g === void 0 ? 1 : _g, _h = _a.timePickerVariant, timePickerVariant = _h === void 0 ? 'default' : _h;
    var valueProps = {
        is12h: is12h,
        value: value,
        onChange: onChange,
        valueHeight: valueHeight,
        maxVisible: maxVisible,
        min: min,
        max: max,
        minuteStep: minuteStep,
    };
    return (timePickerVariant === 'default' ? (React__default.createElement(Container$2, { "data-testid": "time-picker", className: className },
        React__default.createElement(hourValues.HourValues, tslib_es6.__assign({}, valueProps)),
        React__default.createElement(minuteValues.MinuteValues, tslib_es6.__assign({}, valueProps)),
        React__default.createElement(amPmValues.AmPmValues, tslib_es6.__assign({}, valueProps)))) : (React__default.createElement("div", { "data-testid": "time-picker-single-select", className: className },
        React__default.createElement(SingleSelectValues, tslib_es6.__assign({}, valueProps)))));
};
var templateObject_1$2;

exports.TimePicker = TimePicker;
